import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-274eb4d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex-column" }
const _hoisted_2 = { class: "d-flex-1f d-overflow-not" }
const _hoisted_3 = {
  key: 0,
  class: "d-justify-space-around tabbar"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "首页", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "邻里互助", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "活动预约", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "我的", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_view)
    ]),
    true
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(["d-flex-column d-flex-w-center d-justify-space-around item", { active: _ctx.active == 'home' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goPage('/mulin')))
          }, [
            _createVNode(_component_van_icon, { name: "wap-home-o ico" }),
            _hoisted_4
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["d-flex-column d-flex-w-center d-justify-space-around item", { active: _ctx.active == 'mutualAid' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goPage('/mulin/mutualAid')))
          }, [
            _createVNode(_component_van_icon, { name: "smile-comment-o ico" }),
            _hoisted_5
          ], 2),
          _createElementVNode("div", {
            class: "d-flex-column d-flex-w-center d-justify-space-around bg-mark",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goPage('/mulin/mutualAid/edit')))
          }, " + "),
          _createElementVNode("div", {
            class: _normalizeClass(["d-flex-column d-flex-w-center d-justify-space-around item", { active: _ctx.active == 'appointment' }]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goPage('/mulin/appointment')))
          }, [
            _createVNode(_component_van_icon, {
              name: "flower-o",
              size: "24"
            }),
            _hoisted_6
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["d-flex-column d-flex-w-center d-justify-space-around item", { active: _ctx.active == 'my' }]),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goPage('/mulin/my')))
          }, [
            _createVNode(_component_van_icon, { name: "manager-o ico" }),
            _hoisted_7
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ]))
}